// @flow

import React, { type Node, Fragment } from 'react';
import styled from 'styled-components';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';
import warningIconSrc from './sad-face.svg';
import { useTranslateErrorMessageTags } from '@tectonics/controller/error-messages';
import { Link } from '../../../atoms/';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

type Props = {|
  error: PlaceOrderErrorPayload,
|};

export function ErrorDisplay({ error }: Props): Node {
  const translatedError = useTranslateErrorMessageTags(error.message);

  return (
    <ErrorMessageWrapper data-test-id="page-opened-error">
      <Icon src={warningIconSrc} alt="warning icon" />
      <div>
        {translatedError.map(({ text, tag }, i) => {
          if (tag !== 'support') {
            return <Fragment key={i}>{text}</Fragment>;
          }
          return <SupportLink key={i}>{text}</SupportLink>;
        })}
      </div>
    </ErrorMessageWrapper>
  );
}

type SupportLinkProps = {
  +children: Node;
}

function SupportLink({ children }: SupportLinkProps): Node {
  const country = getCountry(useIncomingPayment());

  if (country !== 'br') {
    throw new Error('support tag translation not supported by contries other than br');
  }

  return (
    <Link href="https://ajuda.ebanx.com/hc/pt-br" target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
}

const ErrorMessageWrapper = styled.div`
  background: ${props => props.theme.colors.warning(84)};
  color: ${props => props.theme.colors.green(32)};
  border-top: 2px solid ${props => props.theme.colors.warning(59)};
  border-radius: 0 0 5px 5px;
  font-size: 0.86em;
  display: flex;
  padding: 10px 15px;
`;

const Icon = styled.img`
  margin-right: 10px;
`;
